import { useTranslation } from 'react-i18next';
interface RadarlistToggleProps {
  radarlistOnly: boolean;
  onChange: (value: boolean) => void;
}

function tabClass(active: boolean) {
  return [
    'px-3 py-1 rounded-md text-sm font-medium transition-colors cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    active
      ? 'bg-background text-foreground shadow-sm'
      : 'text-muted-foreground hover:text-foreground',
  ].join(' ');
}

export function RadarlistToggle({ radarlistOnly, onChange }: RadarlistToggleProps) {
  const { t } = useTranslation('analysis');

  return (
    <div className="flex items-center gap-1 rounded-lg bg-surface p-1 shrink-0">
      <button
        type="button"
        aria-pressed={!radarlistOnly}
        onClick={() => onChange(false)}
        className={tabClass(!radarlistOnly)}
      >
        {t('opportunitiesRoom.radarlistToggle.all')}
      </button>
      <button
        type="button"
        aria-pressed={radarlistOnly}
        onClick={() => onChange(true)}
        className={tabClass(radarlistOnly)}
      >
        {t('opportunitiesRoom.radarlistToggle.radarList')}
      </button>
    </div>
  );
}
